import React from 'react';
import cns from 'classnames';
import PropTypes from 'prop-types';
import useModalContext from './useModalContext';

/**
 * Corpo della modale.
*/
const Body = ({ className, children, scrollable }) => {
  const { overflow, maxHeight } = useModalContext();

  return (
    <div className={cns('v2-modal__body', { 'v2-modal--body--scrollable': scrollable }, className)} style={{ overflow, maxHeight }}>
      {children}
    </div>
  );
};

Body.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  /** Gestisce un contenuto che può necessitare di scroll */
  scrollable: PropTypes.bool,
};

Body.defaultProps = {
  scrollable: false,
  className: undefined,
};

export default Body;
